"use client";

import React from "react";
import { useConnection } from "wagmi";
import { Navigate, useLocation } from "react-router-dom";
import { COOKIE_KEY } from "../../constants/cookie";
import { MENU_LINK } from "~/src/utils/common";

interface AuthRedirectProps {
  children: React.ReactNode;
}

/**
 * AuthRedirect - Redirects authenticated users away from login page
 * Requires a live wallet connection as well as session cookies.
 */
export const AuthRedirect: React.FC<AuthRedirectProps> = ({ children }) => {
  const location = useLocation();
  const { isConnected } = useConnection();

  // Get cookies
  const getCookie = (name: string): string | null => {
    if (typeof document === "undefined") {
      return null;
    }
    const cookies = document.cookie.split("; ");
    const cookie = cookies.find((row) => row.startsWith(`${name}=`));
    return cookie ? cookie.split("=")[1] : null;
  };

  const accessToken = getCookie(COOKIE_KEY.accessToken);
  const connectedWallet = getCookie(COOKIE_KEY.connectedWallet);

  // If authenticated and on login page, redirect to profile
  if (
    isConnected &&
    accessToken &&
    connectedWallet &&
    location.pathname === MENU_LINK.LOGIN
  ) {
    return <Navigate to={`/profile/${connectedWallet}`} replace />;
  }

  return <>{children}</>;
};
